<template>
  <header class="tw-mb-11">
    <h2 class="tw-text-[1.7rem] tw-font-bold">{{ t('auth.titles.mfa').toUpperCase() }}</h2>
    <p class="tw-text-base tw-font-light">{{ t('auth.titles.enter_mfa_code') }}</p>
  </header>

  <div
    v-if="errorMessage"
    class="tw-bg-red-100 tw-border tw-border-red-400 tw-text-red-700 tw-px-4 tw-py-3 tw-rounded tw-mb-4"
    role="alert"
  >
    {{ errorMessage }}
  </div>

  <Form class="tw-flex tw-flex-col" v-slot="{ errors, isSubmitting }" @submit="verifyEnteredCode">
    <div class="tw-mb-7">
      <label for="code" class="tw-text-[0.9rem] tw-mb-1 tw-block">
        {{ t('auth.titles.code') }}
      </label>

      <Field
        id="code"
        name="code"
        type="text"
        class="tw-w-full tw-border tw-border-[#d8d8d8] tw-rounded-lg tw-text-[0.9rem] tw-px-3 tw-py-1.5 placeholder:tw-text-[#dcdcdc] placeholder:tw-text-[0.9rem] focus:tw-outline-none"
        :class="{ 'tw-border-danger': errors.code }"
        :placeholder="t('auth.titles.enter_code')"
        :rules="codeRules"
      />

      <div v-if="errors.code" class="tw-text-danger tw-text-xs tw-mt-1">{{ errors.code }}</div>
    </div>

    <button
      class="tw-bg-cta-primary tw-text-white tw-rounded-lg tw-min-h-[2.4rem] tw-mb-6 disabled:tw-opacity-70"
      :disabled="isSubmitting"
    >
      {{ t('common.forms.verify') }}
    </button>
  </Form>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth.store';
import { storeToRefs } from 'pinia';

import { useI18n } from 'vue-i18n';
import { Form, Field } from 'vee-validate';
import { string } from 'yup';

const { t } = useI18n();
const codeRules = string()
  .required(t('auth.titles.code_required'))
  .matches(/^\d{6}$/, t('auth.titles.code_invalid'));

const props = defineProps<{
  codeReceivedFrom: 'TOTP' | 'SMS' | null;
}>();

const { errorMessage } = storeToRefs(useAuthStore());
const { verifyCode } = useAuthStore();

const verifyEnteredCode = async (values: any) => {
  const mfaMethod = props.codeReceivedFrom as 'TOTP' | 'SMS';
  await verifyCode(values.code, mfaMethod);
};
</script>

<style scoped>
/* Using Tailwind classes - no additional styles needed */
</style>
